// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var DateFns = require("date-fns");
var Caml_option = require("rescript/lib/js/caml_option.js");
var CalendarDate = require("../../reason/common/types/CalendarDate.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var FragmentErrorBoundary = require("../common/ErrorHandling/FragmentErrorBoundary.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyPageRentalPropertySidecardMlsInfo_mlsPlan_graphql = require("../../__generated__/PropertyPageRentalPropertySidecardMlsInfo_mlsPlan_graphql.bs.js");
var PropertyPageRentalPropertySidecardMlsInfo_property_graphql = require("../../__generated__/PropertyPageRentalPropertySidecardMlsInfo_property_graphql.bs.js");

var convertFragment = PropertyPageRentalPropertySidecardMlsInfo_mlsPlan_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyPageRentalPropertySidecardMlsInfo_mlsPlan_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyPageRentalPropertySidecardMlsInfo_mlsPlan_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyPageRentalPropertySidecardMlsInfo_mlsPlan_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyPageRentalPropertySidecardMlsInfo_mlsPlan_graphql.node, convertFragment, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyPage__RentalPropertySidecard__MlsInfo$FromMlsPlan(props) {
  var mlsPlan = use(props.mlsPlan);
  var onMlsAt;
  switch (mlsPlan.__typename) {
    case "ListOnMlsAsActive" :
        onMlsAt = mlsPlan.onMlsAt;
        break;
    case "ListOnMlsAsComingSoon" :
        onMlsAt = mlsPlan.activeOnMlsOn;
        break;
    case "NoMlsPlan" :
    case "__unselected" :
        return null;
    
  }
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                            children: "On MLS",
                            className: "text-gray-500 uppercase font-medium tracking-wide"
                          }),
                      JsxRuntime.jsx("div", {
                            children: DateFns.format(CalendarDate.toLocalDate(onMlsAt), "MMM d, YYY"),
                            className: "text-lg font-medium"
                          })
                    ],
                    className: "space-y-2"
                  }),
              className: Core__Option.getOr(props.className, "")
            });
}

var FromMlsPlan = {
  Fragment: Fragment,
  make: PropertyPage__RentalPropertySidecard__MlsInfo$FromMlsPlan
};

var convertFragment$1 = PropertyPageRentalPropertySidecardMlsInfo_property_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyPageRentalPropertySidecardMlsInfo_property_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyPageRentalPropertySidecardMlsInfo_property_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyPageRentalPropertySidecardMlsInfo_property_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyPageRentalPropertySidecardMlsInfo_property_graphql.node, convertFragment$1, fRef);
}

var Fragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function PropertyPage__RentalPropertySidecard__MlsInfo$WithoutErrorBoundary(props) {
  var match = use$1(props.property);
  return JsxRuntime.jsx(PropertyPage__RentalPropertySidecard__MlsInfo$FromMlsPlan, {
              mlsPlan: match.mlsPlan.fragmentRefs,
              className: props.className
            });
}

var WithoutErrorBoundary = {
  Fragment: Fragment$1,
  make: PropertyPage__RentalPropertySidecard__MlsInfo$WithoutErrorBoundary
};

function PropertyPage__RentalPropertySidecard__MlsInfo(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
              fragmentDisplayName: "property MLS info",
              children: JsxRuntime.jsx(PropertyPage__RentalPropertySidecard__MlsInfo$WithoutErrorBoundary, {
                    property: props.property,
                    className: props.className
                  })
            });
}

var make = PropertyPage__RentalPropertySidecard__MlsInfo;

exports.FromMlsPlan = FromMlsPlan;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* date-fns Not a pure module */
